import script from "./SpinnerDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpinnerDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SpinnerDialog.vue?vue&type=style&index=0&id=7873de48&lang=css"

const __exports__ = script;

export default __exports__